module.exports = __webpack_public_path__ + "static/img/tedian3.86b836f5.png";